import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { URLSafeNanoId } from '../../../safe_nanoid';
import { AppContext, DividedEachPageState, UploadError } from './types';
import { AppSteps } from '../../../api/api.type';

const initialState: AppContext = {
    dividedEachPage: DividedEachPageState.FALSE,
    sessionId: URLSafeNanoId(16),
    appStep: AppSteps.NONE,
    errors: []
};

export const appContextSlice = createSlice({
    name: 'context',
    initialState,
    reducers: {
        toggleDividedEachPageAction: (state, { payload: { from } }: PayloadAction<{ from: string }>) => {
            if (from === 'header' && state.dividedEachPage !== DividedEachPageState.TRUE) {
                state.dividedEachPage = DividedEachPageState.TRUE;
            } else if (from === 'header' && state.dividedEachPage === DividedEachPageState.TRUE) {
                state.dividedEachPage = DividedEachPageState.FALSE;
            } else if (from === 'separator' && state.dividedEachPage === DividedEachPageState.TRUE) {
                state.dividedEachPage = DividedEachPageState.INACTIVE;
            }
        },
        resetDividedEachPageAction: state => {
            state.dividedEachPage = DividedEachPageState.FALSE;
        },
        setAppStepAction: (state, { payload }: PayloadAction<AppSteps>) => {
            state.appStep = payload;
        },
        setPropsAction: (
            state,
            {
                payload: { program, programMode, environment, showTutorial }
            }: PayloadAction<Pick<AppContext, 'program' | 'programMode' | 'environment' | 'showTutorial'>>
        ) => {
            state.program = program;
            state.programMode = programMode;
            state.environment = environment;
            state.showTutorial = showTutorial;
        },
        addErrors: (state, { payload }: PayloadAction<UploadError[]>) => {
            state.errors = [...state.errors, ...payload];
        },
        clearErrors: state => {
            state.errors = [];
        }
    }
});

export default appContextSlice.reducer;
